export default __webpack_public_path__ + "static/media/baby-seat-addon.43e96f06.svg";